import { render, staticRenderFns } from "./IconFileRemove.vue?vue&type=template&id=7a515f98&"
import script from "./IconFileRemove.vue?vue&type=script&lang=js&"
export * from "./IconFileRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports